let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3aSzL")).then(() => parcelRequire('6bGTm'));